"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ProtocolTile = function (_a) {
    var value = _a.value, id = _a.id, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, fontAwesomeClassName = _a.fontAwesomeClassName, text = _a.text, BOEInterestRate = _a.BOEInterestRate;
    var isSelected = value === id;
    return (React.createElement("div", { className: "protocol-tile ".concat(isSelected ? 'protocol-tile-active' : ''), onClick: function () {
            setFieldValue('protocol_id', id);
            if (id === 1) {
                setFieldValue('interest_rate', 8.0);
                setFieldValue('representative_name', '');
                // Stops rep name error message displaying when switching back to individual trader from business
                setFieldTouched('representative_name', false);
            }
            else if (id === 2) {
                setFieldValue('interest_rate', 8 + BOEInterestRate);
            }
        } },
        React.createElement("div", { className: "protocol-tile-icon" },
            React.createElement("i", { className: fontAwesomeClassName })),
        React.createElement("div", { className: "protocol-tile-text" }, text)));
};
exports.default = ProtocolTile;
